export default __webpack_public_path__ + "static/media/our-values-Header-4k.88c1b70b.jpg";